import { ReactComponent as PrintIcon } from 'assets/icons/print.svg';
import React from 'react';
import './PrintButton.scss';

const PrintButton = ({ handlePrint, isDesktopLayout, className }) => {
  return isDesktopLayout ? (
    <a
      data-testid="print-button"
      className={`${className} print-button-container`}
      onClick={handlePrint}>
      <span className="print-button-title">Print</span>
      <PrintIcon className={`${className} print-icon`} />
    </a>
  ) : (
    <div className="print-button-container">
      <PrintIcon className={`${className} print-icon`} />
    </div>
  );
};

export default PrintButton;
